import React from "react";
import { Link } from "react-router-dom";

export const agentLeadColumns = ({ handleDelete, PAGE_SIZE, viewRemark}) => [
  {
    label: "Lead ID",
    width: 100,
    render: (row) =>
      <Link to="#">
                {row.leadId ? (
                  <span>#{row.leadId}</span>
                ) : (
                  <span>-</span>
                )}
      </Link>
  },

  {
    label: "Client Details",
    key: "name",
    width: 250,
    sortable: true,
    render: (row) => (
      <div className="userdet">
        <div>
          <i className="far fa-user" /> {row.name || "-"}
        </div>
        <div>
          <i className="far fa-mobile-alt" /> {row.mobile || "-"}
        </div>
        <div>
          <i className="far fa-envelope" /> {row.email || "-"}
        </div>
      </div>
    ),
  },

 

  {
    label: "Date",
    width: 120,
    render: (row) => (
      <>
      
        <span>{row?.createdAt
                ? new Date(row.createdAt).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })
                : "-"}
                </span>
        
      </>
    ),
  },

  {
    label: "Follow Up",
    width: 140,
    render: (row) => (
      <a href="#" className="sitebtn text-white text-center px-1 py-0 mb-2" style={{ fontSize: 12, textDecoration: "none", display: "inline-block" }} data-toggle="modal" data-target="#remarkModal" title="View Follow Up"   onClick={() => viewRemark(row)}>
            <i className="fa fa-eye" aria-hidden="true"></i> View
        </a>
    ),
  },

  {
    label: "Action",
    width: 90,
    render: (row) => (
      <ul className="actionlist p-0 m-0" style={{ listStyle: "none" }}>
        <li>
          <a
            href="#"
            title="Delete Lead"
            className="text-danger"
            style={{ fontSize: 16, cursor: "pointer" }}
            onClick={(e) => {
              e.preventDefault();
              handleDelete(row);
            }}
          >
            <i className="fa fa-trash text-danger" />
          </a>
        </li>
      </ul>
    ),
  },

  {
    label: "Status",
    width: 120,
    render: (row) => (
            row.leadStatus === "Pending" ? (
                <span className="badge badge-warning">Pending</span>
            ) : row.leadStatus === "InProgress" ? (
                <span className="badge badge-info">In Progress</span>
            ) : row.leadStatus === "Not Interested" ? (
                <span className="badge badge-danger">Not Interested</span>
            ) :row.leadStatus === "Paid" ? (
                <span className="badge badge-success">Paid</span>
            ) :row.leadStatus === "Rejected" ? (
                <span className="badge badge-danger">Rejected</span>
            ) :(
                <span className="badge badge-secondary">{row.leadStatus}</span>
            )
        ),
  },
];
